import { useLocation as useWouterLocation } from 'wouter';

const useLocation = () => {
  const [location, setLocation] = useWouterLocation();

  return [location, setLocation, window.location.search];
}

export default useLocation;
